<template>
  <div class="space-between-y">
    <div class="space-between-x container-left">
      <input-item label="关键字搜索">
        <el-input clearable v-model="form.keyword" placeholder="请输入关键字"/>
      </input-item>
      <input-item>
        <el-button type="primary" @click="getData()">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="users" border stripe>
      <el-table-column show-overflow-tooltip label="用户编号" prop="id"/>
      <el-table-column show-overflow-tooltip label="昵称" prop="nickname"/>
      <el-table-column show-overflow-tooltip label="手机号" prop="phone"/>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>

  </div>
</template>

<script>

import {user} from "@/api/user";
import Pagination from "@/components/base/layout/Pagination.vue";
import InputItem from "@/components/base/layout/InputItem.vue";

export default {
  name: 'MiuList',
  components: {InputItem, Pagination},

  data() {
    return {
      users: [],

      form: {
        keyword: "",
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      user.miuList(this.page.size, this.page.current, this.form.keyword).then(res => {
        let page = res.data;
        this.users = page.list;
        this.page.total = page.total;
      });
    },
  },


};
</script>

<style scoped>
</style>
